msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: invite.inviter_name
#: src/components/InviteLanding.tsx
msgid "{0} invited you to this Project."
msgstr "{0} invited you to this Project."

#: src/components/InviteLanding.tsx
msgid "Accept invitation"
msgstr "Accept invitation"

#: src/components/InviteLanding.tsx
msgid "Add selected agents"
msgstr "Add selected agents"

#: src/components/RegisterPage.tsx
msgid "Already have an account? Log in"
msgstr "Already have an account? Log in"

#: src/i18n/authMessages.ts
msgid "An account with this email already exists. Try signing in."
msgstr "An account with this email already exists. Try signing in."

#: src/i18n/authMessages.ts
msgid "Borgee cannot create an account for this Microsoft account: it has no name or email address to show. Add one to your Microsoft profile, or use password login."
msgstr "Borgee cannot create an account for this Microsoft account: it has no name or email address to show. Add one to your Microsoft profile, or use password login."

#: src/i18n/authMessages.ts
msgid "Borgee could not create a local session. Please try again."
msgstr "Borgee could not create a local session. Please try again."

#: src/components/InviteLanding.tsx
msgid "Bring your agents"
msgstr "Bring your agents"

#: src/components/LoginPage.tsx
msgid "Continue with Microsoft"
msgstr "Continue with Microsoft"

#: src/components/InviteLanding.tsx
msgid "Could not add the selected agents. Please try again."
msgstr "Could not add the selected agents. Please try again."

#: src/i18n/authMessages.ts
msgid "Could not create your account. Check your details and invite code."
msgstr "Could not create your account. Check your details and invite code."

#: src/i18n/authMessages.ts
msgid "Could not create your account. Please try again."
msgstr "Could not create your account. Please try again."

#: src/i18n/authMessages.ts
msgid "Could not sign in. Please try again."
msgstr "Could not sign in. Please try again."

#: src/components/RegisterPage.tsx
msgid "Create Account"
msgstr "Create Account"

#: src/components/RegisterPage.tsx
msgid "Creating account..."
msgstr "Creating account..."

#: src/components/RegisterPage.tsx
msgid "Display Name"
msgstr "Display Name"

#: src/components/RegisterPage.tsx
msgid "Display name must be 1-50 characters"
msgstr "Display name must be 1-50 characters"

#: src/components/LoginPage.tsx
#: src/components/RegisterPage.tsx
msgid "Email"
msgstr "Email"

#: src/components/LoginPage.tsx
msgid "Have an invite code? Register"
msgstr "Have an invite code? Register"

#: src/components/RegisterPage.tsx
msgid "Invalid email format"
msgstr "Invalid email format"

#: src/components/RegisterPage.tsx
msgid "Invite Code"
msgstr "Invite Code"

#. placeholder {0}: invite.guild_name
#: src/components/InviteLanding.tsx
msgid "Join {0}"
msgstr "Join {0}"

#: src/components/InviteLanding.tsx
msgid "Loading invitation…"
msgstr "Loading invitation…"

#: src/components/LoginPage.tsx
msgid "Log in"
msgstr "Log in"

#: src/components/LoginPage.tsx
msgid "Logging in..."
msgstr "Logging in..."

#: src/i18n/authMessages.ts
msgid "Microsoft could not verify this sign-in. Please start again."
msgstr "Microsoft could not verify this sign-in. Please start again."

#: src/i18n/authMessages.ts
msgid "Microsoft could not verify this sign-in. Please try again."
msgstr "Microsoft could not verify this sign-in. Please try again."

#: src/i18n/authMessages.ts
msgid "Microsoft sign-in could not be completed. Password login still works."
msgstr "Microsoft sign-in could not be completed. Password login still works."

#: src/i18n/authMessages.ts
msgid "Microsoft sign-in is not enabled. Password login still works."
msgstr "Microsoft sign-in is not enabled. Password login still works."

#: src/i18n/authMessages.ts
msgid "Microsoft sign-in is temporarily busy. Please try again."
msgstr "Microsoft sign-in is temporarily busy. Please try again."

#: src/i18n/authMessages.ts
msgid "Microsoft sign-in is temporarily unavailable. Password login still works."
msgstr "Microsoft sign-in is temporarily unavailable. Password login still works."

#: src/i18n/authMessages.ts
msgid "Microsoft sign-in was cancelled."
msgstr "Microsoft sign-in was cancelled."

#: src/components/InviteLanding.tsx
msgid "No eligible active agents are available."
msgstr "No eligible active agents are available."

#: src/components/LoginPage.tsx
msgid "or"
msgstr "or"

#: src/components/LoginPage.tsx
#: src/components/RegisterPage.tsx
msgid "Password"
msgstr "Password"

#: src/components/RegisterPage.tsx
msgid "Password must be at least 8 bytes"
msgstr "Password must be at least 8 bytes"

#: src/components/RegisterPage.tsx
msgid "Password must be at most 72 bytes"
msgstr "Password must be at most 72 bytes"

#: src/components/RegisterPage.tsx
msgid "Register"
msgstr "Register"

#: src/components/InviteLanding.tsx
msgid "Select active agents to add to this Project. None are selected by default."
msgstr "Select active agents to add to this Project. None are selected by default."

#: src/i18n/authMessages.ts
msgid "Sign-in was not accepted. Check your credentials or contact an administrator."
msgstr "Sign-in was not accepted. Check your credentials or contact an administrator."

#: src/components/InviteLanding.tsx
msgid "Skip"
msgstr "Skip"

#: src/i18n/authMessages.ts
msgid "This email already belongs to a Borgee account. Continue with password login."
msgstr "This email already belongs to a Borgee account. Continue with password login."

#: src/components/InviteLanding.tsx
msgid "This invitation is unavailable."
msgstr "This invitation is unavailable."

#: src/i18n/authMessages.ts
msgid "This invite code is invalid or no longer available. Request a new invite code."
msgstr "This invite code is invalid or no longer available. Request a new invite code."

#: src/i18n/authMessages.ts
msgid "This Microsoft account belongs to a deleted Borgee account."
msgstr "This Microsoft account belongs to a deleted Borgee account."

#: src/i18n/authMessages.ts
msgid "This Microsoft sign-in link expired. Please start again."
msgstr "This Microsoft sign-in link expired. Please start again."

#: src/i18n/authMessages.ts
msgid "This Microsoft sign-in link is invalid or has already been used."
msgstr "This Microsoft sign-in link is invalid or has already been used."

#: src/i18n/authMessages.ts
msgid "This Microsoft sign-in return path is invalid. Please start again."
msgstr "This Microsoft sign-in return path is invalid. Please start again."

#: src/i18n/authMessages.ts
msgid "Too many registration attempts. Please try again later."
msgstr "Too many registration attempts. Please try again later."

#: src/i18n/authMessages.ts
msgid "Too many sign-in attempts. Please try again later."
msgstr "Too many sign-in attempts. Please try again later."

#: src/i18n/authMessages.ts
msgid "Your session ended. Sign in again."
msgstr "Your session ended. Sign in again."
